import type { MissionView } from "@frontier/content/contracts";
import { escortRouteLength } from "@frontier/content/escort-contracts";
import { EscortRoutePreview } from "./EscortRoutePreview";

export function EscortMissionStatus({ mission }: { mission: MissionView }) {
  const terms = mission.terms.escort;
  if (!terms) return null;
  const canonical = mission.escort;
  const view = mission.escortView;
  const arrived = canonical?.phase === "arrived";
  const lost = canonical?.phase === "lost";
  const required = escortRouteLength(terms) * terms.minimumDistanceRatio;
  const live = arrived || lost ? null : view;
  const distance = live?.escortedDistance ?? canonical?.distance ?? 0;
  const contribution =
    (live?.damage ?? canonical?.damage ?? 0) +
    (live?.healing ?? canonical?.healing ?? 0);
  const participation =
    required > 0 ? Math.min(100, Math.floor((distance / required) * 100)) : 0;
  const status = arrived
    ? "ДОСТАВЛЕН · ВЕРНИСЬ НА СТАНЦИЮ"
    : lost
      ? "ТРАНСПОРТ ПОТЕРЯН"
      : view?.status === "confirming" ||
          view?.status === "arrived" ||
          view?.status === "lost"
        ? "ПОДТВЕРЖДАЕМ РЕЗУЛЬТАТ"
        : view?.status === "cooldown"
          ? "ЖДИ СЛЕДУЮЩЕГО КОНВОЯ"
          : view?.status === "active"
            ? "КОНВОЙ В ПУТИ"
            : "ВСТРЕТЬ КОНВОЙ У СТАРТА";
  return (
    <div
      className="escort-mission-status"
      aria-label="Сопровождение транспорта"
    >
      <strong className={lost ? "lost" : arrived ? "arrived" : ""}>
        {status}
      </strong>
      <EscortRoutePreview
        terms={terms}
        name={mission.title}
        view={view}
        objective={mission.objective}
      />
      {view?.transportId && view.transportMaxHp > 0 && !lost && (
        <label className="escort-transport-health">
          <span>
            КОРПУС ТРАНСПОРТА{" "}
            <b>
              {Math.ceil(view.transportHp)}/{view.transportMaxHp}
            </b>
          </span>
          <progress
            aria-label="Корпус транспорта"
            max={view.transportMaxHp}
            value={view.transportHp}
          />
        </label>
      )}
      <div className="escort-personal-progress">
        <span className={participation >= 100 ? "fulfilled" : "missing"}>
          ТВОЁ СОПРОВОЖДЕНИЕ {participation}%
        </span>
        {terms.minimumContribution > 0 && (
          <span
            className={
              contribution >= terms.minimumContribution
                ? "fulfilled"
                : "missing"
            }
          >
            БОЙ / РЕМОНТ{" "}
            {Math.min(terms.minimumContribution, Math.floor(contribution))}/
            {terms.minimumContribution}
          </span>
        )}
      </div>
      {!arrived && !lost && (
        <small>Двигайся рядом и защищай транспорт до точки назначения.</small>
      )}
    </div>
  );
}
